/* Stolen & Modified version of atlas-ui select that adds a search box */

import {Component, OnInit, inject} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {AgencyTag} from 'src/app/models/agency-tag';
import {CurrentSelection} from 'src/app/models/current-selection';
import {AgencyTagService} from 'src/app/services/agencytag.service';
import {FilterService} from 'src/app/services/filter.service';
import {SelectOption} from 'src/app/models/select';
import {MultiSelectSearchComponent} from '../multi-select-search/multi-select-search.component';

@Component({
  selector: 'app-filter-agency-tag',
  templateUrl: './filter-agency-tag.component.html',
  styleUrls: ['./filter-agency-tag.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, MultiSelectSearchComponent],
})
export class FilterAgencyTagComponent implements OnInit {
  private agencyTagService = inject(AgencyTagService);
  private filterService = inject(FilterService);

  agencyTagData: SelectOption[];
  defaultOption: string;
  agencyTagFilterFormControl = new FormControl([]);

  ngOnInit(): void {
    this.defaultOption = 'Profile Tag';
    this.toggleEnabledDisabled();
    this.getAgencyTagList();
    this.subscribeToFilterSelectionChanges();
  }

  updateAgencyTagFilter(): void {
    const selectedValues = this.agencyTagData
      .filter(
        (atd) =>
          this.agencyTagFilterFormControl.value.findIndex(
            (v) => v === atd.value
          ) > -1
      )
      .map((v) => {
        if (Array.isArray(v.value)) {
          throw new Error(
            'Agency Tag Filter Component can only use SelectOption as SelectDataSource'
          );
        }
        return new CurrentSelection(v.value, v.label);
      });
    this.filterService.addMultiValuedFilter('agencyTagId', selectedValues);
  }

  private getAgencyTagList(): void {
    this.agencyTagService
      .getAgencyTagList()
      .pipe()
      .subscribe((agencyTags: AgencyTag[]) => {
        this.agencyTagData = this.mapAgencyTagsToSelect(agencyTags);
        this.toggleEnabledDisabled();
      });
  }

  private mapAgencyTagsToSelect(agencyTags: AgencyTag[]): SelectOption[] {
    if (!agencyTags) return [];

    const result = agencyTags.map((at) => ({
      label: at.name,
      value: at.agencyTagId.toString(),
    }));
    return result;
  }

  private toggleEnabledDisabled() {
    if (this.agencyTagData && this.agencyTagData.length > 0) {
      this.agencyTagFilterFormControl.enable();
    } else {
      this.agencyTagFilterFormControl.disable();
    }
  }

  private subscribeToFilterSelectionChanges(): void {
    this.filterService.currentSelectionsChange$.subscribe(() => {
      const currentAgencyTagIdSelections = this.filterService.currentSelections
        .agencyTagId;
      if (!currentAgencyTagIdSelections) {
        this.agencyTagFilterFormControl.reset([]);
        return;
      }
      this.agencyTagFilterFormControl.patchValue(
        currentAgencyTagIdSelections.map((cs) => cs.filterValue)
      );
    });
  }
}
